import dictionary from './emoji.json'
import emoji from 'emoji-dictionary'

export const transformToEmoji = text => {
  const originalText = text
  let newText = text
  let replaced = false
  const words = text.split(/(\s+)/).filter(e => e.trim().length > 0)
  const replaces = []
  //use array in case text was copied and pasted
  for (let word of words) {
    for (const [key, value] of Object.entries(dictionary)) {
      if (value.shortcut.some(s => s === word)) {
        replaces.push({ original: word, newText: emoji.getUnicode(key) })
        replaced = true
      }
    }
  }
  for (let replace of replaces) {
    newText = newText.replaceAll(replace.original, replace.newText)
  }
  return { newText, originalText: originalText + ' ', replaced }
}
